import { Box } from '@chakra-ui/react';

import SessionVariantsProduct from '../SessionVariantsProduct';
import SessionVariantsByList from './SessionVariantsByList';
import SessionVariantsByQuantity from './SessionVariantsByQuantity';

const SessionVariantsBloc = ({
  product,
  availabilities,
  availability,
  displayVariantsAsQuantity,
  commonPropsForVariantDisplay,
  sameSessionIndex,
  onRemoveSameSession,
}) => {
  const commonPropsSessionVariants = {
    availability: availability,
    sameSessionIndex: sameSessionIndex,
    ...commonPropsForVariantDisplay,
  };

  return (
    <Box>
      <SessionVariantsProduct
        product={product}
        availabilities={availabilities}
        sameSessionIndex={sameSessionIndex}
        onRemoveSameSession={onRemoveSameSession}
      />

      {displayVariantsAsQuantity && <SessionVariantsByQuantity {...commonPropsSessionVariants} />}
      {!displayVariantsAsQuantity && <SessionVariantsByList {...commonPropsSessionVariants} />}
    </Box>
  );
};

export default SessionVariantsBloc;
